import {
  ContentStateInterface,
  ContentStateProperty,
  EstateFeatureProps,
  EstateFeatures,
  RealEstateFeatures,
} from '../../@types/types'
import { estateFeaturesLanguages } from './estateFeatures'
import { ChipGroupFeature } from '../../components/common/inputs/chipsGroup/ChipsGroup'

export const getEstateFeatures = (
  realEstateFeatures: EstateFeatureProps[],
  insertionData: ContentStateInterface,
  hasInitialWBSValue = false
): ChipGroupFeature[] => {
  return realEstateFeatures.map((estateFeature: EstateFeatureProps) => {
    // The WBS option should not be editable if user already has a running contract when it is already selected
    // the flag addressEditable is appropriate here because it has the same logic behind as the address editability
    // see https://github.com/Scout24/central-listings-backend/blob/main/src/main/java/de/is24/offer/hof/infrastructure/utils/AddressEditabilityUtils.kt
    const isWBSDisabled =
      estateFeature.property === RealEstateFeatures.CERTIFICATE_OF_ELIGIBILITY_NEEDED &&
      insertionData.addressEditable != undefined &&
      !insertionData.addressEditable &&
      hasInitialWBSValue

    const feature: ChipGroupFeature = {
      property: `estateFeatures.${estateFeature.property}` as ContentStateProperty,
      translationKey: estateFeature.translationKey,
      value: insertionData.estateFeatures?.[estateFeature.property as keyof EstateFeatures] ?? false,
      defaultTranslationText: estateFeaturesLanguages[estateFeature.property],
    }

    if (isWBSDisabled) {
      feature.disabled = true
    }

    return feature
  })
}
